module.exports = __webpack_public_path__ + "img/warning.8d7dc8d8.svg";